import { render, staticRenderFns } from "./wallet-filters.vue?vue&type=template&id=27c78e15&"
import script from "./wallet-filters.vue?vue&type=script&lang=js&"
export * from "./wallet-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27c78e15')) {
      api.createRecord('27c78e15', component.options)
    } else {
      api.reload('27c78e15', component.options)
    }
    module.hot.accept("./wallet-filters.vue?vue&type=template&id=27c78e15&", function () {
      api.rerender('27c78e15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/wallet-filters/wallet-filters.vue"
export default component.exports